import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { CommonService } from "../../../services/common.service";
// import { start } from "repl";

@Component({
  selector: "app-insurance-provider-master",
  templateUrl: "./insurance-provider-master.component.html",
  styleUrls: ["./insurance-provider-master.component.css"]
})
export class InsuranceProviderMasterComponent implements OnInit {
  actionmode: string = "Search";
  showList: boolean = false;
  screen_details: any = [];
  searchlist: boolean = false;

  validflag = false;
  validflagform = {};

  editFlag: any = false;
  screentitle: string = "Insurance Provider Master";
  search_details: any = [];
  viewpage = false;
  searchresult = false;
  searchtabledata: any = [];
  loader: any = false;
  parent_table = "UB_MST_INSURANCE_PROVIDER";

  childtables = [];
  EditData: any = [];
  filters = [];
  delete_id = "";

  dbFields = [
    "map_id", "value"
  ];
  constructor(private vernostService: VernostServiceService, private commonService: CommonService) { }
  ngOnInit() {
    this.searchData(true);
  }

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
    this.validflag = false;
    this.validflagform = {};

  }

  searchForm(show_error_msg) {
    this.actionmode = "Search";
    this.screen_details = [];
    this.editFlag = false;
    document.getElementById("errs").innerHTML = "";
    this.viewpage = false;
    // this.search_details = [];
    this.searchData(show_error_msg);
  }
  submitcancelData() {
    this.validate()

    let formDataID;
    if (this.EditData.length > 0) {
      formDataID = this.EditData[0]["id"];
    }
    var formData = [
      this.screen_details.Id,
      this.screen_details.Name,
    ];

    if (this.editFlag == false) {

      this.checkRecordInDB().then(isRecordIn_DB => {
        if (!isRecordIn_DB) {
          var data = {
            parent_table: this.parent_table,
            dbFields: this.dbFields,
            formData: formData,
            // USER_ID: this.uid,
            PAGENAME: "BANNER"
          };
          this.vernostService.insertData(data).subscribe(res => {
            if (res[0].message == "Data inserted") {
              this.removeEditScreen();
              this.showMessagePopup("Record Inserted Successfully");
              this.screen_details = [];
              this.validflag = false;

            } else {
              this.showMessagePopup("Record Not Inserted Successfully");
            }
          });
        }
      })
    }
    if (this.editFlag == true) {

      var arrayInsuranceProviderMaster = {
        parent_table: this.parent_table,
        dbFields: this.dbFields,
        parent_table_ID: "id",
        formData: formData,
        formdataId: formDataID,
        USER_ID: ""
      };
      this.vernostService.editData(arrayInsuranceProviderMaster).subscribe(resp => {
        if (resp != undefined && resp[0].status != "Failed") {

          this.removeEditScreen();
          this.showMessagePopup("Record Updated Successfully")
          this.screen_details = [];
          this.validflag = false;

        } else {
          this.showMessagePopup("Record Not Updated Successfully")
        }
      });

    }
  }
  searchData(show_error_msg) {
    this.searchlist = false;
    this.loader = true;
    var errors = document.getElementsByClassName("search_err");
    // var valid_search_flag = false, valid_search_fields = false;
    for (let i = 0; i < errors.length; i++) {
      var key = errors[i].id;
      if (this.search_details[key] != undefined && this.search_details[key] != "") {
        // valid_search_flag = true;
        break;
      }
    }
    for (var searchKey in this.search_details) {

      if (this.search_details[searchKey] != undefined && this.search_details[searchKey] != "") {
        // valid_search_fields = true;
        break;
      }
    }
    var searchitem = [];
    var searchColumn = [];

    searchColumn.push("1=1");
    searchitem.push("");
    var dataInsuranceProviderMaster = {
      parent_table: this.parent_table,
      dbFields: searchColumn,
      searchData: searchitem,
      childtables: this.childtables,
      filters: this.filters
    };

    this.vernostService.searchRecord(dataInsuranceProviderMaster).subscribe(response => {
      this.loader = false;
      this.searchtabledata = response;
      if (response.length > 0) {
        this.searchresult = true;
        this.searchtabledata = response;
        document.getElementById("errs").innerHTML = "";


      } else {
        this.searchresult = false;
        // document.getElementById("errs").innerHTML = 
        this.showMessagePopup("Record not found");
      }
    });

  }
  showFormData(data, flag) {
    this.EditData = [];
    console.log("data", data);
    this.EditData.push(data);
    console.log("data", this.EditData);

    if (flag == 1) {
      this.editFlag = false;

      this.actionmode = "view";
      this.viewpage = true;


    } else {
      this.editFlag = true;
      this.delete_id = data.ID;

      this.actionmode = "Edit";
      this.screen_details.Id = data.map_id;
      this.screen_details.Name = data.value;

    }
    this.validflag = this.validate();

  }

  numCheck(id) {

    this.validflagform[id] = this.commonService.numcheck(this.screen_details[id], id, /^[0-9]+$/);
    this.validflag = this.validate();
  }

  decimalCheck(id) {
    this.validflagform[id] = this.commonService.numcheck(this.screen_details[id], id, /^[0-9]+(\.[0-9]+)?$/);
    this.validflag = this.validate();
  }

  blankCheck(id) {
    this.validflagform[id] = this.commonService.blankcheck(this.screen_details[id], id);
    this.validflag = this.validate();

  }
  deleteData() {
    var delete_Req = {
      ID: this.delete_id
    };
    this.vernostService.DeleteInsuranceArray(delete_Req).subscribe(res => {
      if (res != undefined && res[0]["status"] == "Success") {
        this.screen_details = [];
        this.removeEditScreen();
        this.showMessagePopup("Record Deleted Successfully")
      } else {
        this.showMessagePopup("Record Not Deleted Successfully")
      }

    });
  }
  removeEditScreen() {

    this.actionmode = "Search";
    this.editFlag = false;
    this.viewpage = false;
    document.getElementById("errs").innerHTML = "";
    this.searchForm(false);
  }
  showMessagePopup(msg) {
    document.getElementById("errs").innerHTML = msg;
    setTimeout(() => {
      document.getElementById("errs").innerHTML = "";
    }, 2000);
  }
  setScreen(screen) {

    this.actionmode = "Search";
    this.screen_details = [];
    this.editFlag = false;
    this.validflag = false;
    document.getElementById("errs").innerHTML = "";
    this.viewpage = false;
    this.searchresult = false;
    this.search_details = [];
    this.loader = false;
    // this.search_details.Id = '';
  }
  validate() {
    var errs = document.getElementsByClassName("err");

    for (var e = 0; e < errs.length; e++) {
      var key = errs[e].id.slice(0, -4);
      // console.log("--:",key,">>>",this.screen_details[key],",vald:",this.validflagform[key])
      if (this.validflagform[key] == undefined) {
        if (this.screen_details[key] === undefined || this.screen_details[key] == null || this.screen_details[key] === "") {
          this.validflagform[key] = false;
          // console.log("''''flse:",key,">>>",this.screen_details[key])
          return false;
        }
        else
          this.validflagform[key] = true;
      }
      else {
        if (this.validflagform[key] === false) {
          // console.log("flse:",key,">>>",this.validflagform[key],">>val>>",this.screen_details[key])
          return false;
        }
      }
    }
    return true;

  }
  checkRecordInDB() {
    return new Promise(resolve => {

      var data = {
        parent_table: this.parent_table,
        dbFields: ["map_id"],
        searchData: [this.screen_details.Id],
        childtables: this.childtables,
        filters: this.filters
      }

      this.vernostService.searchRecord(data).subscribe(res => {
        this.loader = false;
        if (res.length > 0) {
          this.showMessagePopup("Record already exists !");
          resolve(true);
        } else {
          resolve(false);
        }
      });
    })
  }
  checkLimit(id, min, max) {
    this.validflagform[id] = this.commonService.checkLimit(id, min, max, this.screen_details[id], this.validflagform[id]);
    this.validflag = this.validate();
  }
}